import React, { Component } from 'react'
import { Link } from 'app/common/link'
import styled from 'styled-components'

type Props = {
    url: string,
    image: string
}

class ImageButton extends Component<Props> {
    render() {
        const { url, image } = this.props

        return (
            <AppButton url={url} external={true}>
                <AppStoreImg src={image} />
            </AppButton>
        )
    }
}

const AppButton = styled(Link)`
    width: 96%;
    border-radius: 4px;
`

const AppStoreImg = styled.img`
    width: inherit;
`

export { ImageButton }
